import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import {CustomersService} from '../../home/services/customers.service';
import {OrderService} from '../services/order.service';

@Component({
  selector: 'app-change-email--confirmation',
  templateUrl: './change-email-confirmation.component.html',
  styleUrls: ['./change-email-confirmation.component.css']
})
export class ChangeEmailConfirmationComponent implements OnInit {
  processing = true;
  confirmed = false;

  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
  ) { }

  error: string;

  ngOnInit() {
    const token =  this.route.snapshot.queryParamMap.get('token');
    this.orderService.confirmChangeEmail(token).subscribe(result => {
      this.error = '';
      this.confirmed = true;
      this.processing = false;
    }, error => {


      if( error.error === 'Nothing to do' ){
        this.error = 'inactive';
      } else if( error.error === 'differnt emails' ){
        this.error = 'different';
      } else if( error.error === 'f' ){
        this.error = 'incorrect';
      } else if( error.error === 'Token expired' || error.error == 'exp' || error.error == 'expired' ){
        this.error = 'expired';
      } else{
        this.error = 'other';
      }

      console.log(this.error);

      this.confirmed = false;
      this.processing = false;
    });
  }

}
